import { Spinner } from '@change/ds-core-ui/Spinner';

export const Loading = <Spinner className="mx-auto my-64" />;
